<template>
  <div class="double-choice-card" @click="handleOpenDoubleChoice">
    <div
      class="card-header"
      :style="{
        backgroundImage: `url('${info.mbannerUrl || info.imageUrl}')`,
      }"
      :class="{ 'default-image': !info.mbannerUrl && !info.imageUrl }"
    >
      <div class="card-time">
        <div>{{ info.startTime }}</div>
      </div>
    </div>
    <div class="card-info">
      <div class="card-title ellipsis">{{ info.jobFairName }}</div>
      <div class="card-content">
        企业 <span style="color: #333">{{ info.companyNum }}</span
        >家<span style="padding: 0 5px">|</span>参与
        <span style="color: #333">{{ info.studentNum }}</span
        >人
      </div>
    </div>
  </div>
</template>

<script>
import { addRecommendEffectMonitoring } from '@/api/rd.js'
export default {
  props: ['info', 'from'],
  data() {
    return {}
  },
  methods: {
    handleOpenDoubleChoice() {
      const query = this.$route.query
      if (query.id && this.from === 'hall') {
        addRecommendEffectMonitoring({
          recommendId: query.id,
          jobFairId: this.info.jobFairId,
          sourceCode: '推荐大厅-双选会推荐-双选会-点击',
        })
      }
      if (this.info.customizationFairUrl) {
        window.location.href = this.info.customizationFairUrl
      } else {
        window.location.href = `https://zhaopin.com/sxh/${this.info.jobFairId}`
      }
    },
  },
}
</script>

<style lang="less" scoped>
.double-choice-card {
  background: #ffffff;
  border-radius: 6px;
  margin-bottom: 8px;
  width: 100vw * 172 / 375;

  .card-header {
    height: 100vw * 100 / 375;
    background: 0 0 no-repeat;
    background-size: 100% 100%;
    border-radius: 8px 8px 0 0;
    position: relative;
    .card-time {
      position: absolute;
      bottom: 0;
      width: 100%;
      line-height: 20px;
      color: #fff;
      font-size: 12px;
      background-color: rgba(0, 0, 0, 0.1);
      padding: 0 10px;
      box-sizing: border-box;
      div {
        transform-origin: left;
        transform: scale(0.9);
      }
    }
  }
  .default-image {
    background-image: url('../../assets/rd/job-fair.png') !important;
  }

  .card-info {
    padding: 6px 10px 4px;
    .card-title {
      color: #000;
      font-size: 14px;
      // font-weight: bold;
    }
    .card-content {
      color: #888;
      font-size: 12px;
      line-height: 20px;
      transform-origin: left;
      transform: scale(0.92);
    }
  }
}
</style>
